// Iterative Levenshtein with a single rolling row. Allocates O(min(m, n))
// memory and runs in O(m*n) time. Plenty fast for country-name comparisons
// (max ~50 chars) — no need for the Wagner–Fischer matrix or DP table cache.

export const levenshtein = (a: string, b: string): number => {
  if (a === b) return 0;
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  // Iterate over the shorter string in the inner loop for less allocation.
  let s1 = a;
  let s2 = b;
  if (s1.length > s2.length) {
    const swap = s1;
    s1 = s2;
    s2 = swap;
  }

  const len1 = s1.length;
  const len2 = s2.length;
  const row = new Array<number>(len1 + 1);
  for (let i = 0; i <= len1; i++) row[i] = i;

  for (let j = 1; j <= len2; j++) {
    let prev = row[0]!;
    row[0] = j;
    for (let i = 1; i <= len1; i++) {
      const temp = row[i]!;
      if (s1.charCodeAt(i - 1) === s2.charCodeAt(j - 1)) {
        row[i] = prev;
      } else {
        row[i] = 1 + Math.min(prev, row[i - 1]!, row[i]!);
      }
      prev = temp;
    }
  }
  return row[len1]!;
};
